namespace $.$$ {

	export class $shm_tests_app_run extends $.$shm_tests_app_run {

		data() {
			return this.result() as $shm_tests_app_result | null
		}

		run_title() {
			const data = this.data()
			if( !data ) return 'Результат теста'
			if( this.video_uri() ) {
				const player = this.Player()
				const range = player.current_step_range()
				return `${ player.current_title() }${ range ? ` · ${ range }` : '' }`
			}
			return `${ this.status_icon( data.run.status ) } ${ this.display_title() || data.scenario.title }`
		}

		override player_controls() {
			return this.video_uri() ? [ this.Player().Controls() ] : []
		}

		status_icon( status: string ) {
			switch( status ) {
				case 'passed': return '✓'
				case 'failed': return '✕'
				case 'aborted': return '■'
				default: return '○'
			}
		}

		body_rows() {
			const data = this.data()
			if( !data ) return []
			const has_visual = data.steps.some( step => Boolean( step.visual?.length ) )

			return [
				...( this.video_uri() || has_visual ? [ this.Player() ] : [] ),
				...( this.other_artifacts().length ? [ this.Artifacts() ] : [] ),
				...( data.error ? [ this.Error() ] : [] ),
			]
		}

		videos() {
			return this.data()?.artifacts.filter( artifact => artifact.mime.startsWith( 'video/' ) ) ?? []
		}

		video_uri() {
			const path = this.videos()[ 0 ]?.path
			return path ? this.resolve_artifact( path ) : ''
		}

		other_artifacts() {
			return this.data()?.artifacts.filter( artifact => (
				!artifact.mime.startsWith( 'image/' )
				&& !artifact.mime.startsWith( 'video/' )
			) ) ?? []
		}

		artifact_rows() {
			return this.other_artifacts().map( artifact => this.Artifact( artifact.path ) )
		}

		artifact_uri( path: string ) {
			return this.resolve_artifact( path )
		}

		artifact_title( path: string ) {
			return path
		}

		resolve_artifact( path: string ) {
			return new URL( path.replace( /\\/g, '/' ), new URL( this.manifest_uri(), this.$.$mol_dom_context.location.href ) ).toString()
		}

		error_text() {
			const error = this.data()?.error
			return error ? `# Ошибка\n\n${ error.message }\n\n\`\`\`\n${ error.stack ?? '' }\n\`\`\`` : ''
		}

	}

}
